import { SBSearchType, SBSortingOrder } from "@bookingcom/flights-searchbox";

import {
  UIOccupancyAndCabinClass,
  UIFetchStatus,
  UIDateFares,
  UIClientFetchError,
  UIFlightTimesAgg,
  UISearchSegment
} from "@flights/types";

export const SEARCH_DATE_FORMAT = "yyyy-MM-dd";

type Filters = {
  stops: number | undefined;
  duration: number | undefined;
  airlines: string[] | undefined;
  departureIntervals: number[][];
  arrivalIntervals: number[][];
  flightTimes: UIFlightTimesAgg;
  shortLayoverConnection?: boolean;
  includedBaggage?: string[];
  maxBudget?: number;
  maxBudgetPerAdult?: number;
  airports?: string[];
  preferSameAirport?: string;
  maxLayoverDuration?: number;
  allDeals?: boolean;
};

export type UIFareCalendarFare = {
  fetchStatus: UIFetchStatus;
  dateFares: UIDateFares[] | [];
  error?: UIClientFetchError;
};

export type State = {
  type: SBSearchType;
  searchSegments: UISearchSegment[];
  sort: SBSortingOrder;
  page: number;
  filters: Filters;
  filtersDraft: Filters;
  /* start - flights_split_bounds_us */
  filtersDraftOutbound: Filters;
  filtersDraftInbound: Filters;
  /* end - flights_split_bounds_us */
  isDirect: boolean;
  fareCalendar: UIFareCalendarFare;
} & UIOccupancyAndCabinClass;

const initialFiltersState = {
  stops: undefined,
  duration: undefined,
  airlines: undefined,
  departureIntervals: [],
  arrivalIntervals: [],
  maxBudgetPerAdult: undefined,
  flightTimes: [],
  allDeals: false
};

export const getInitialState = (): State => ({
  type: "ROUNDTRIP",
  searchSegments: [
    {
      from: [],
      to: [],
      departureDate: undefined,
      returnDate: undefined
    }
  ],
  adults: 1,
  children: [],
  cabinClass: "ECONOMY",
  sort: "BEST",
  page: 1,
  filters: { ...initialFiltersState },
  filtersDraft: { ...initialFiltersState },
  filtersDraftOutbound: { ...initialFiltersState },
  filtersDraftInbound: { ...initialFiltersState },
  isDirect: false,
  fareCalendar: {
    fetchStatus: "initial",
    dateFares: [],
    error: undefined
  }
});
